const __WEBPACK_NAMESPACE_OBJECT__ = require("@testing-library/react");